<template>
  <div class="overflow-hidden">
    <div class="bg-light-purple">
      <div
        class="featured-height overflow-hidden overflow-visible-l container phx20 flex-l items-center-l tc tl-l"
      >
        <div class="pa2 pv4-l pl0-l pr4-l w-40-l mb5-l">
          <h1 class="ma0 mb4 mt4-l f1">
            {{ $t('proSignup.heading') }}
          </h1>
          <p class="dn db-l pb4 mb3">{{ $t('proSignup.subheading') }}</p>
          <a
            class="pointer dib white fw7 br-pill bg-purple button-large"
            @click="$root.$emit('handle-download', 'open')"
          >
            {{ $t('proSignup.beginProSignup') }}
          </a>
        </div>
        <div class="h-100 w-60-l relative overflow-hidden">
          <div class="layer-1 relative" :style="`top: -${scrolled * 0.2}px`">
            <img
              :data-srcset="require('~/assets/images/home-phone@2x.png').srcSet"
              data-src="~assets/images/home-phone.png"
              alt=""
              class="lazyload featured-phone"
              width="500"
              height="681"
            />
          </div>
          <div class="layer-2 relative" :style="`top: -${scrolled * 0.4}px`">
            <img
              data-src="~/assets/icons/ic_bubble_5.svg"
              alt=""
              width="90"
              height="95"
              class="lazyload featured-bubble-5"
            />
            <img
              data-src="~/assets/icons/ic_bubble_6.svg"
              alt=""
              width="84"
              height="93"
              class="featured-bubble-6 lazyload"
            />
          </div>
          <div class="layer-3 relative" :style="`top: -${scrolled * 0.6}px`">
            <img
              data-src="~/assets/icons/ic_bubble_1.svg"
              alt=""
              width="34"
              height="34"
              class="featured-bubble-1 lazyload"
            />
            <img
              data-src="~/assets/icons/ic_bubble_2.svg"
              alt=""
              width="34"
              height="34"
              class="featured-bubble-2 lazyload"
            />
            <img
              data-src="~/assets/icons/ic_bubble_3.svg"
              alt=""
              width="34"
              height="34"
              class="featured-bubble-3 lazyload"
            />
            <img
              data-src="~/assets/icons/ic_bubble_4.svg"
              alt=""
              width="34"
              height="34"
              class="featured-bubble-4 lazyload"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="bg-near-white">
      <div class="container pax20">
        <h2 class="f2 mt5">{{ $t('proSignup.benefitsTitle') }}</h2>
        <div class="flex-l pv4 na3">
          <div class="w-25-l pa3">
            <img
              data-src="~/assets/icons/ic_earnings_large.svg"
              alt=""
              width="130"
              height="90"
              class="lazyload"
            />
            <h3 class="f3">{{ $t('proSignup.benefits.title1') }}</h3>
            <p>{{ $t('proSignup.benefits.description1') }}</p>
          </div>
          <div class="w-25-l pa3">
            <img
              data-src="~/assets/icons/ic_insurance_large.svg"
              alt=""
              width="94"
              height="90"
              class="lazyload"
            />
            <h3 class="f3">{{ $t('proSignup.benefits.title2') }}</h3>
            <p>{{ $t('proSignup.benefits.description2') }}</p>
          </div>
          <div class="w-25-l pa3">
            <img
              data-src="~/assets/icons/ic_bills_large.svg"
              alt=""
              width="90"
              height="90"
              class="lazyload"
            />
            <h3 class="f3">{{ $t('proSignup.benefits.title3') }}<br /></h3>
            <p>{{ $t('proSignup.benefits.description3') }}</p>
          </div>
          <div class="w-25-l pa3">
            <img
              data-src="~/assets/icons/ic_help_large.svg"
              alt=""
              width="110"
              height="90"
              class="lazyload"
            />
            <h3 class="f3">{{ $t('proSignup.benefits.title4') }}</h3>
            <p>{{ $t('proSignup.benefits.description4') }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="container pax20">
      <div class="flex flex-column items-center flex-row-l mv4">
        <div class="w-50-l mr2 flex justify-center">
          <div class="mv4 features-mw">
            <h2 class="f2 mb4 mt2">
              {{ $t('proSignup.features.feature1Title') }}
            </h2>
            <p class="">
              {{ $t('proSignup.features.feature1Description') }}
            </p>
          </div>
        </div>
        <div class="w-50-l ml2">
          <div class="pv4 flex justify-center features-screen features-mw">
            <img
              :data-srcset="require('~/assets/images/guide-find@2x.png').srcSet"
              data-src="~assets/images/guide-find.png"
              alt=""
              class="lazyload"
              width="274"
              height="477"
            />
          </div>
        </div>
      </div>
      <div
        class="flex flex-column items-center flex-row-l flex-row-reverse-l mb4"
      >
        <div class="w-50-l ml2 flex justify-center">
          <div class="mv4 features-mw">
            <h2 class="f2 mt2">{{ $t('proSignup.features.feature2Title') }}</h2>
            <p class="">{{ $t('proSignup.features.feature2Description') }}</p>
          </div>
        </div>
        <div class="w-50-l mr2 flex justify-end">
          <div class="pv4 flex justify-center features-screen features-mw flip">
            <img
              :data-srcset="
                require('~/assets/images/guide-manage@2x.png').srcSet
              "
              data-src="~assets/images/guide-manage.png"
              alt=""
              class="lazyload flip"
              width="274"
              height="477"
            />
          </div>
        </div>
      </div>
      <div class="flex flex-column items-center flex-row-l">
        <div class="w-50-l mr2 flex justify-center">
          <div class="mv4 features-mw">
            <h2 class="f2 mt2">{{ $t('proSignup.features.feature3Title') }}</h2>
            <p class="">{{ $t('proSignup.features.feature3Description') }}</p>
          </div>
        </div>
        <div class="w-50-l ml2">
          <div class="pv4 flex justify-center features-screen features-mw">
            <img
              :data-srcset="require('~/assets/images/guide-pay@2x.png').srcSet"
              data-src="~assets/images/guide-pay.png"
              alt=""
              class="lazyload"
              width="274"
              height="477"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="bg-near-white">
      <div
        class="featured-container-dn flex flex-column items-center flex-row-l tl relative"
      >
        <div class="container pax20 w-100">
          <div class="pr6-l ph0-m w-50-l">
            <h2 class="f2">
              {{ $t('proSignup.downloadNow.heading') }}
            </h2>
            <p class="mb2 pb2">{{ $t('proSignup.downloadNow.subheading') }}</p>

            <div class="flex">
              <a
                class="pointer dib white mt3 mb4 fw7 br-pill bg-green button-large"
                @click="$root.$emit('handle-download', 'open')"
              >
                {{ $t('proSignup.downloadNow.cta') }}
              </a>
            </div>
          </div>
        </div>
        <div
          class="featured-image-container-dn absolute-l top-0 right-0 w-50-l"
        >
          <img
            :data-srcset="require('~/assets/images/download-app@2x.jpg').srcSet"
            data-src="~assets/images/download-app@2x.jpg"
            class="lazyload featured-image-dn"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  scrollToTop: true,
  data() {
    return {
      error: null,
      success: null,
      phone: null,
      scrolled: 0,
    };
  },
  mounted() {
    window.addEventListener('scroll', this.onScroll);
  },
  destroyed() {
    window.removeEventListener('scroll', this.onScroll);
  },
  methods: {
    onScroll() {
      this.scrolled = window.pageYOffset;
    },
  },
  head() {
    return {
      title: this.$t('proSignup.title'),
      meta: [
        // hid is used as unique identifier. Do not use `vmid` for it as it will not work
        {
          hid: 'description',
          name: 'description',
          content: this.$t('proSignup.description'),
        },
        {
          hid: 'og:description',
          property: 'og:description',
          content: this.$t('proSignup.description'),
        },
        {
          hid: 'og:title',
          property: 'og:title',
          content: this.$t('proSignup.title'),
        },
        {
          hid: 'og:url',
          property: 'og:url',
          content: `https://discontract.com${this.$route.path.replace(
            /\/?$/,
            '/'
          )}`,
        },
      ],
    };
  },
};
</script>
